import React from 'react';

export function NavLink({ href, children }) {
  const handleClick = (e) => {
    // Only handle hash links
    if (href && href.startsWith('#')) {
      e.preventDefault();
      
    
      
      // Get the element ID
      const id = href.substring(1);
      const element = document.getElementById(id);
      
     
      
      if (element) {
        // Scroll to the element with offset
        const headerOffset = 80;
        
        // Try this different approach to scrolling
        element.scrollIntoView({ behavior: 'smooth' });
        
        // Apply the offset after scrolling
        setTimeout(() => {
          window.scrollBy({
            top: -headerOffset,
            behavior: 'smooth'
          });
        }, 100);
      } else {
        console.error(`Element with id '${id}' not found`);
        
        // Fall back to trying to find the element by section
        const sections = document.querySelectorAll('section');
        let found = false;
        
        sections.forEach(section => {
          if (section.id === id) {
            found = true;
           
            section.scrollIntoView({ behavior: 'smooth' });
            
            // Apply the offset after scrolling
            setTimeout(() => {
              const headerOffset = 80;
              window.scrollBy({
                top: -headerOffset,
                behavior: 'smooth'
              });
            }, 100);
          }
        });
        
        if (!found) {
          console.error(`Could not find any section with id: ${id}`);
        }
      }
    }
  };

  return (
    <a
      href={href}
      onClick={handleClick}
      className="inline-block rounded-lg px-2 py-1 text-sm text-slate-700 hover:bg-slate-100 hover:text-slate-900 no-underline cursor-pointer"
    >
      {children}
    </a>
  );
}
